import React          from 'react'
import classnames   	from 'classnames'
import EventSummary 	from '../common/EventSummary'
import AnchorLink   	from '../common/AnchorLink'
import BannerPicture 	from '../common/BannerPicture'
import Ad             from '../common/Ad'

export const Competitor = ({
  id = '',
  name = '',
  shortName = '',
  abbrev = '',
  logo = '',
  bannerLogo = '',
  scoreMarkup = '',
  team = 'home',
  trackingName = '',
  rank,
  record,
  possession,
  href = '',
  uid,
  sport,
  isTeamLinkActive,
  isWebView
}) => {

  const isHome = team === 'home'

  const picture = `
    <picture>
      <!--[if IE 9]><video style="display: none;"><![endif]-->
      <source srcset="${logo}">
      <!--[if IE 9]></video><![endif]--><img data-default-src="${logo}" class="team-logo lazyload" data-src="${logo}" />
    </picture>
  `

  const teamBanner = (
  <div key="tb" className="team__banner">
    <div className="team__banner__wrapper">
      <BannerPicture bannerLogo={bannerLogo} teamId={id} />
    </div>
  </div>
  )

  const teamName = [
    <span className="long-name" key="ln">{name}</span>,
    <span className="short-name" key="sn">{sport === 'cricket' ? shortName : name}</span>,
    <span className="abbrev" key="ab">{abbrev}</span>
  ]

  const teamLogo = ( <div key="nc" className="logo" dangerouslySetInnerHTML={{ __html: logo && picture || '' }} /> )
  let logoWrapper = <div key="l" className="team-info-logo">{teamLogo}</div>
  let linkTeamName = <div className="team-name">{teamName}</div>
  let linkProps = { 'name': trackingName, 'isRouterLink': false, 'data-uid': uid, 'classes': 'app_partial team-info-logo', 'data-linktype':'clubhouse' }
  let linkPropsTeamName = { ...linkProps, 'classes': 'team-name app_partial' }

  if(!isWebView) {
    linkProps.to = href
    linkPropsTeamName.to = href
  }

  if(href != '') {
    logoWrapper = <AnchorLink key="l" children={teamLogo} {...linkProps} />
    linkTeamName = <AnchorLink key="ltn" children={teamName} {...linkPropsTeamName} />
  }

  const teamInfo = (
    <div key={'ti'} className="team-info">
		<div className="team-info-wrapper">
			<span className="rank">{rank}</span>
			{
			isTeamLinkActive &&
			linkTeamName
			}
		</div>
		{ record && <span className="record">{record}</span> }
    </div>
  )

  const teamContainer = (
    <div key={'tc'} className="team-container">
      {
        isHome ? [ teamInfo, logoWrapper ] : [ logoWrapper, teamInfo ]
      }
    </div>
  )

  const scoreContainer = (
    <div key={'sc'} className="score-container">
      <div className={classnames('score', isHome ? 'icon-font-after' : 'icon-font-before')} dangerouslySetInnerHTML={{ __html : scoreMarkup }}>
      </div>
    </div>
  )

  return (
    <div className={classnames('team', isHome ? 'team-a' : 'team-b', { possession: possession })}>
		<div className="team__content">
			{
				isHome ? [ teamBanner, teamContainer, scoreContainer ] : [ teamBanner, scoreContainer, teamContainer ]
			}
		</div>
    </div>
  )
}

export const GameDetailsFooter = ({
  summaryData = {},
  summaryText = '',
  mobileText  = '',
  className   = '',
  sport       = '',
  gameState   = 'pregame'
}) => {

  let details = []
  let sportClass = sport
  if( (sport === 'rugby' || sport === 'rugby-league') && gameState !== 'pregame' ) {
    //sportClass = 'rugby'
    details.push(
      <EventSummary key="summary" summary={ summaryData } />
    )
  }

  if ( summaryText ) {
    details.push(
      <div key="status" className="game-status">{ summaryText }</div>
    )
  }

  if ( mobileText || summaryText) {
    details.push(
      <div key="mob-status" className="game-status mobile">{ mobileText || summaryText }</div>
    )
  }

  if ( details.length == 0 ) {
    return (
      <script />
    )
  }

  return (
    <div className={classnames('game-details footer', className, sportClass)}>
      <div className="wrap">
        { details }
      </div>
    </div>
  )
}

export const LongStripAd = ({
  edition = {}
}) => {

  let details = []
  let excludeVal1 = [ 's' ]
  let excludeVal2 = [ 's', 'm' ]

  if(edition.isAsiaRegion) {
    details.push(
      <div key="LongStripAd" className="ad-double-longstrip-wrapper">
        <div key="longstrip1" className="ad-double-longstrip">
          <Ad className="react-ad ad-slot-longstrip ad-wrapper" slotType="longstripGamepackage" kvpos="left" exclude={excludeVal1} />
        </div>
        <div key="longstrip2" className="ad-double-longstrip">
          <Ad className="react-ad ad-slot-longstrip ad-wrapper" slotType="longstripGamepackage" kvpos="right" exclude={excludeVal2} />
        </div>
      </div>
    )
  }

  return (
    <div>
    { details }
    </div>
  )
}

export const GameStrip = ({
  header      = '',
  network     = '',
  time        = '',
  date        = '',
  target      = '',
  teams       = {},
  sport       = '',
  className   = '',
  winnerClass = '',
  homeTeamBattedFirst = true,
  isTeamLinkActive    = true,
  isWebView
}) => {

  // Swap team 1 and team 2 in case home team did not bat first
  let team1 = homeTeamBattedFirst ? teams.home : teams.away
  let team2 = homeTeamBattedFirst ? teams.away : teams.home

  let sportClass = sport
  if( sport === 'rugby-league' ) {
    sportClass = 'rugby'
  }

  /* TODO: REMOVE THIS INLINE STYLE ONCE IT IS ADDED IN THE SCORE REPO */
  const hotFixStyle = `
    <style type="text/css">
      @media screen and (min-width: 768px) {
        body.webview.cricket.gamepackage .game-strip {
          display: block !important;
        }
      }
    </style>
  `

  return (
    <header className={classnames('game-strip game-package', sportClass, className, winnerClass)}>
        <span style={{ 'display': 'none' }} dangerouslySetInnerHTML={{ __html: hotFixStyle }}></span>
        <div className="game-details header">
            {header}
        </div>
        <div className="competitors">
            <Competitor team="home" {...team1} sport={sport} isTeamLinkActive={isTeamLinkActive} isWebView={isWebView} />
            <div className="game-status">
                { network && <span className="network">{ network }</span> }
                { date && <span className="game-date">{ date }</span> }
                { time && <span className="game-time">{ time }</span> }
                { target && <span className="game-play">{ target }</span> }
            </div>
            <Competitor team="away" {...team2} sport={sport} isTeamLinkActive={isTeamLinkActive} isWebView={isWebView} />
        </div>
    </header>
  )
}

export const ScoreCellCompetitor = ({
  name = '',
  abbrev = '',
  logo = '',
  scoreMarkupMobile = '',
  team = 'home',
  rank,
  href,
  uid,
  trackingName = '',
  isWebView
}) => {

  const picture = `
    <picture>
      <!--[if IE 9]><video style="display: none;"><![endif]-->
      <source srcset="${logo}">
      <!--[if IE 9]></video><![endif]--><img data-default-src="${logo}" class="cscore_image lazyload" data-src="${logo}" />
    </picture>
  `
  let defaultLinkLogo = []
  let defaultLinkAbbr = []

  let defaultLinkProps = { 'name' : trackingName, 'data-uid' : uid, 'className' : 'app_partial cscore_logo', 'data-linktype' : 'clubhouse' }
  let defaultLinkAbbrProps = { ...defaultLinkProps , 'className' : 'app_partial' }

  if(!isWebView) {
    defaultLinkProps.href = href
    defaultLinkAbbrProps.href = href
  }

  const teamname = [
    <span key="l" className="cscore_name cscore_name--long">{name}</span>,
    <span key="s" className="cscore_name cscore_name--short">{name}</span>,
    <span key="a" className="cscore_name cscore_name--abbrev">{abbrev}</span>
  ]

  const spanAbbrTag = (
    <span className="cscore_truncate">{teamname}</span>
  )
  const divLogoTag = (
    <div className="cscore_logo" dangerouslySetInnerHTML={{ __html: logo && picture || '' }} />
  )

  if(href != '' && href != '#') {
    defaultLinkLogo.push(
      <a key="l2" dangerouslySetInnerHTML={{ __html: logo && picture || '' }} { ...defaultLinkProps } />
    )
    defaultLinkAbbr.push(
      <a key="l2a" { ...defaultLinkAbbrProps }>{teamname}</a>
    )
  }else{
    defaultLinkLogo.push(divLogoTag)
    defaultLinkAbbr.push(spanAbbrTag)
  }
  return (
    <li key={team} className={`cscore_item cscore_item--${team}`}>
      {defaultLinkLogo}
      { rank && <div class="cscore_rank">{rank}</div> }
      <div className="cscore_team icon-font-after">
          <div className="cscore_truncate">
            {defaultLinkAbbr}
          </div>
          <div className="cscore_score " dangerouslySetInnerHTML={{ __html: scoreMarkupMobile }}/>
      </div>
    </li>
  )
}

export const ScoreCellHeader = ({
  header      = '',
  network     = '',
  time        = '',
  date        = '',
  teams       = {},
  sport       = '',
  className   = '',
  summaryText = '',
  winnerClassMobile = '',
  homeTeamBattedFirst = true,
  showGameDetailFooter,
  isWebView = false,
  isUpdatesOnly = false,
  gameState = ''
}) => {
  let team1 = homeTeamBattedFirst ? teams.home : teams.away
  let team2 = homeTeamBattedFirst ? teams.away : teams.home

  let sportClass = sport
  if( sport === 'rugby-league' ) {
    sportClass = 'rugby'
  }
  let matchStatusDesc = time && `${time}${(isUpdatesOnly && gameState === 'live') ? ' - Updates only' : ''}` || ''
  return (
      <div className={classnames('cscore', className, sportClass, winnerClassMobile)}>
        <div className="cscore_link cscore_link--button">
          <div className="cscore_overview">
            { (date || time) &&
              <div className="cscore_date-time">
                {date && <span className="cscore_date">{date}</span>}
                {matchStatusDesc && <span className="cscore_time">{matchStatusDesc}</span>}
              </div>
            }
            { header &&
              <div className="cscore_info-overview">{header}</div>
            }
            { network &&
              <div className="cscore_network cscore_network--watch">
                <div className="cscore_channels icon-font-before icon-watch-outline-before">
                <span>{network}</span></div>
              </div> || null
            }
          </div>
          <div className="cscore_details">
            <ul className="cscore_competitors ">
              <ScoreCellCompetitor team="home" {...team1} sport={sport} isWebView={isWebView} />
              <ScoreCellCompetitor team="away" {...team2} sport={sport} isWebView={isWebView} />
            </ul>
          </div>
        </div>
        { summaryText && showGameDetailFooter &&
            <div className="cscore_commentary cscore_commentary--footer">
              <div className="cscore_notes">
                <span className="cscore_notes_game">
                  {summaryText}
                </span>
              </div>
            </div> || null
          }
      </div>
  )
}

export default GameStrip



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/GameStrip.jsx
 **/